module.exports = __webpack_public_path__ + "media/images/work_articles_popup_icon-35431096ebe678f8d82f2598309d7f85.png";